import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/Nina/subs.vtt';
import poster from '@/static/assets/reviews/Nina/video.jpg';

export const Nina: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Car],
  reviewerName: 'Nina',
  videoUrl: `${ASSETS_URL}/car/Nina.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
